import { Button } from '../../../button';
import { Col } from '../../../col';
import { Icon } from '../../../icon';
import { Loading } from '../../../loading';
import { Progress } from '../../../progress';
import { Row } from '../../../row';
import { Text } from '../../../typography';

type P = {
  fileName: string;
  percent: number;
  removeUpload: () => void;
};

const FileUploading = ({ fileName, percent, removeUpload }: P) => (
  <div className="ui-video-status">
    <Row align="middle" className="ui-video-status__file-row" gutter={['xs', 0]}>
      <Col>
        <Loading indicator={<Icon icon="loading-line" spin />} padding={false} size="small" />
      </Col>

      <Col className="ui-video-status__file-name" flex="1">
        <Text ellipsis>{fileName}</Text>
      </Col>

      <Col>
        <Button
          icon={<Icon icon="delete-2-line" />}
          onClick={() => {
            removeUpload();
          }}
          type="link-primary"
        />
      </Col>

      <div className="ui-video-status__progress">
        <Progress percent={percent} showInfo={false} size="small" strokeColor="green" strokeWidth={2} />
      </div>
    </Row>
  </div>
);

export default FileUploading;
